import { useCallback, useState } from 'react';
import { defineMessage } from '@lingui/macro';

import localCache from '../utils/localCache';
import { STORAGE_KEYS } from '../utils/storageKeys';
import useBetaFeatures from './useBetaFeatures';

export const HOME_LAYOUTS = [
  {
    id: 'classic',
    name: defineMessage({ message: 'Classic cards' }),
    description: defineMessage({ message: 'The current card grid.' }),
  },
  {
    id: 'clickable-card',
    name: defineMessage({ message: 'Clickable cards' }),
    description: defineMessage({
      message:
        'The whole card opens the integration; status is a dot beside the name.',
    }),
  },
  {
    id: 'dense-list',
    name: defineMessage({ message: 'Dense list' }),
    description: defineMessage({
      message: 'A sortable table with one integration per row.',
    }),
  },
];

export const DEFAULT_HOME_LAYOUT = 'classic';

const isLayout = (id) => HOME_LAYOUTS.some((layout) => layout.id === id);

const readLayout = () => {
  const stored = localCache.get(STORAGE_KEYS.HOME_LAYOUT);
  return isLayout(stored) ? stored : DEFAULT_HOME_LAYOUT;
};

export default function useHomeLayout() {
  const { isEnabled } = useBetaFeatures();
  const [stored, setStored] = useState(readLayout);

  const setLayout = useCallback((id) => {
    const next = isLayout(id) ? id : DEFAULT_HOME_LAYOUT;
    localCache.set(STORAGE_KEYS.HOME_LAYOUT, next);
    setStored(next);
  }, []);

  const enabled = isEnabled('homeLayouts');

  return {
    layout: enabled ? stored : DEFAULT_HOME_LAYOUT,
    setLayout,
    layouts: HOME_LAYOUTS,
    enabled,
  };
}
